import { TwoUp } from '$components/layouts/twoUp';
import { fontSize, color } from '$components/layouts/config';
import { Paragraph } from '$components/layouts/typography';
import { Translate } from '$components/misc/translate';
import React from 'react'
import { MDXTag } from '@mdx-js/tag'

export default { TwoUp, fontSize, color, Paragraph, Translate, React, MDXTag }